module.exports = __webpack_public_path__ + "static/media/user-campaign-bottom-card.bd3dc351.svg";